var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.482,
    fill: "#707070",
    viewBox: "0 0 15.482 15.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_folder-2",
    "data-name": "vuesax/outline/folder-2",
    transform: "translate(-428 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-2",
    transform: "translate(428 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.16,13.869H3.709C.864,13.869,0,13,0,10.16V3.709C0,.864.864,0,3.709,0h.968A2,2,0,0,1,6.612.968l.968,1.29c.213.284.245.323.645.323H10.16c2.845,0,3.709.864,3.709,3.709v3.87C13.869,13,13,13.869,10.16,13.869ZM3.709.968C1.4.968.968,1.406.968,3.709V10.16c0,2.3.432,2.742,2.742,2.742H10.16c2.309,0,2.742-.439,2.742-2.742V6.29c0-2.3-.432-2.742-2.742-2.742H8.225a1.481,1.481,0,0,1-1.419-.71l-.968-1.29A1.085,1.085,0,0,0,4.677.968Z",
    transform: "translate(0.806 0.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.225,3.793a.487.487,0,0,1-.484-.484v-.89C7.741,1.4,7.309.968,6.29.968H.484A.487.487,0,0,1,0,.484.487.487,0,0,1,.484,0H6.29A2.181,2.181,0,0,1,8.709,2.419v.89A.487.487,0,0,1,8.225,3.793Z",
    transform: "translate(4.677 0.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H15.482V15.482H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.425fe2e937e0f7a1428182b9dc683b05.svg";
export { ForwardRef as ReactComponent };